import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import api from '../../api/api';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const StatsSection = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ total_donors: 0, supported_hospitals: 0, total_amount: 0 });
  const statsRef = useScrollReveal();

  useEffect(() => {
    api.getStats().then(setStats).catch(console.error);
  }, []);

  return (
    <section className="stats">
      <div className="container">
        <div ref={statsRef} className="stats-grid scroll-reveal">
          <div className="stat-item">
            <div className="stat-number"><CountUp end={stats.total_donors} separator="," /></div>
            <div className="stat-label">{t('stats.totalDonors')}</div>
          </div>
          <div className="stat-item">
            <div className="stat-number"><CountUp end={stats.supported_hospitals} /></div>
            <div className="stat-label">{t('stats.supportedHospitals')}</div>
          </div>
          <div className="stat-item">
            <div className="stat-number"><CountUp end={Math.floor(stats.total_amount / 1000000)} />M</div>
            <div className="stat-label">{t('stats.totalAmount')}</div>
          </div>
          <div className="stat-item">
            <div className="stat-number"><CountUp end={100} />%</div>
            <div className="stat-label">{t('stats.transparencyIndex')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
